export const initialFormValues = {
  invoiceDays: '',
  weekdays: '100',
  saturday: '',
  sunday: '',
  distributionType: true,
  holidays: []
}
